import React, { useEffect, useMemo, useRef } from "react";
import CytoscapeComponent from "react-cytoscapejs";

const defaultLayout = {
  name: "cose",
  fit: true,
  padding: 30,
  animate: false,   // 🔒 CRITIQUE
};


const defaultStylesheet = [
  {
    selector: "node",
    style: {
      "background-color": "#5c4b6e",
      label: "data(label)",
      color: "#e5e7eb",
      "font-size": 10,
      "text-valign": "center",
      "text-halign": "center",
      "text-outline-width": 2,
      "text-outline-color": "#27323f",
    },
  },
  {
    selector: "edge",
    style: {
      width: 1,
      "line-color": "rgba(229,231,235,0.35)",
      "target-arrow-color": "rgba(229,231,235,0.35)",
      "target-arrow-shape": "triangle",
      "curve-style": "bezier",
    },
  },
];

export default function GraphCanvas({
  elements = [],
  layout = defaultLayout,
  stylesheet = defaultStylesheet,
  onNodeClick,
}) {
  const cyRef = useRef(null);
  const cyStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);

  /* 🔒 Attacher les events UNE SEULE FOIS */
  useEffect(() => {
    const cy = cyRef.current;
    if (!cy) return;

    const handler = (evt) => {
      onNodeClick?.(evt.target.data());
    };

    cy.on("tap", "node", handler);

    return () => {
      cy.off("tap", "node", handler);
    };
  }, [onNodeClick]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <CytoscapeComponent
        key={elements.length}   // 🔒 force un cycle propre
        elements={elements}
        layout={layout}
        stylesheet={stylesheet}
        style={cyStyle}
        cy={(cy) => {
          cyRef.current = cy;
        }}
      />
    </div>
  );
}
